exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".params-container .params-list[data-v-07fd8676] {\n  margin-top: 15px;\n}\n.params-container .params-list .param-item[data-v-07fd8676] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    margin-bottom: 10px;\n}\n.dialog-footer[data-v-07fd8676] {\n  text-align: right;\n}\n", ""]);

// exports
